import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class UsersService {
  me: any = {
    require_password_update: false,
  };

  private rolesObs = new BehaviorSubject<Array<any>>([]);
  roles$ = this.rolesObs.asObservable();

  private distributorsObs = new BehaviorSubject<Array<any>>([]);
  distributors$ = this.distributorsObs.asObservable();

  private salesRepresentativesObs = new BehaviorSubject<Array<any>>([]);
  salesRepresentatives$ = this.salesRepresentativesObs.asObservable();

  private usersObs = new BehaviorSubject<Array<any>>([]);
  users$ = this.usersObs.asObservable();

  private meObs = new BehaviorSubject<Array<any>>(null);
  me$ = this.meObs.asObservable();

  private messagesObs = new BehaviorSubject<Array<any>>([]);
  messages$ = this.messagesObs.asObservable();

  constructor(private http: HttpClient) {
    this.me$.subscribe((me) => {
      this.me = me;
    });
  }

  setMessagesAllAsRead() {
    return this.http
      .post(`${environment.api}/system-messages/mark-all-as-read`, {})
      .subscribe();
  }

  getMe(callback?) {
    return this.http.get(`${environment.api}/user/me`).subscribe(
      (me: any) => {
        this.meObs.next(me);
        if (callback) {
          callback();
        }
      },
      (err) => {
        console.log(err);
      }
    );
  }

  getMeObs(callback?): Observable<any> {
    return this.http.get(`${environment.api}/user/me`).pipe(
      switchMap((me: any) => {
        this.meObs.next(me);
        if (callback) {
          callback();
        }
        return of(me);
      })
    );
  }

  getMeRequest(): Observable<any> {
    return this.http.get(`${environment.api}/user/me`);
  }

  isAdminAccess() {
    this.me$.subscribe((me: any) => {
      console.log(me.role);
      if (
        me &&
        me.role &&
        (me.role === 'ROLE_SUPER_ADMIN' || me.role === 'ROLE_COORDINATOR')
      ) {
        console.log('admin access');
        return true;
      } else {
        console.log('not admin access');
        return false;
      }
    });
  }

  resetMe() {
    this.meObs.next(null);
  }

  requirePasswordUpdate(): any {
    this.getMe();

    return new Promise((resolve, rejectPromise) => {
      this.me$.subscribe((me) => {
        if (me) {
          if (me['require_password_update'] === true) {
            rejectPromise(this.me.require_password_update);
          } else {
            resolve(this.me.require_password_update);
          }
        }
      });

      // if (this.me) {
      //   if (this.me.require_password_update === true) {
      //     reject(this.me.require_password_update);
      //   } else {
      //     resolve(this.me.require_password_update);
      //   }
      // }
    });
  }

  setPassword(data) {
    return this.http.post(`${environment.api}/user/change-password`, data);
  }

  getUserDetails(id) {
    return this.http.get(`${environment.api}/user/details/${id}`);
  }

  getRoles() {
    return this.http.get(`${environment.api}/user/roles`).subscribe(
      (roles: any) => {
        this.rolesObs.next(roles);
      },
      (err) => {
        console.log(err);
      }
    );
  }

  getDistributors() {
    return this.http.get(`${environment.api}/distributors-dropdown`).subscribe(
      (distributors: any) => {
        this.distributorsObs.next(distributors);
      },
      (err) => {
        console.log(err);
      }
    );
  }

  getSalesRepresentatives() {
    return this.http
      .get(`${environment.api}/sales-representatives-dropdown`)
      .subscribe(
        (salesRepresentatives: any) => {
          this.salesRepresentativesObs.next(salesRepresentatives);
        },
        (err) => {
          console.log(err);
        }
      );
  }

  getUsers(
    sort: string,
    direction: string,
    page: number,
    perPage: number,
    search: string,
    role: string
  ) {
    // eslint-disable-next-line max-len
    return this.http.get(
      `${environment.api}/users?perPage=${perPage}&page=${
        page + 1
      }&direction=${direction}&sort=${sort}&search=${search}&role=${role}`
    );
  }

  getMessages(sort: string, direction: string, page: number, perPage: number) {
    // eslint-disable-next-line max-len
    return this.http.get(
      `${environment.api}/system-messages?perPage=${perPage}&page=${
        page + 1
      }&direction=${direction}&sort=${sort}`
    );
  }

  getUser(id) {
    return this.http.get(`${environment.api}/user/${id}`);
  }

  addUser(user) {
    return this.http.post(`${environment.api}/user`, user);
  }

  saveUser(id, user) {
    return this.http.put(`${environment.api}/user/${id}`, user);
  }

  enableUser(id) {
    return this.http.patch(`${environment.api}/user/${id}/enable`, null);
  }

  disableUser(id) {
    return this.http.patch(`${environment.api}/user/${id}/disable`, null);
  }
}
